const state = {
  lastCreatedData: null // 上次创建的数据
}

const mutations = {
  setLastCreatedData(state, data) {
    state.lastCreatedData = data
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
